export default __webpack_public_path__ + "static/9-3b8bedc052bb9753fe458187430376ae.png";